export const ROUTES = {
  PUBLIC: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    RESET_PASSWORD: '/auth/reset',
    RESET_PASSWORD_CONFIRM: '/auth/reset-confirm',
  },
  PRIVATE: {
    DASHBOARD: '/comprobantes/emision',
    SELECT_WORKSPACE: '/select-workspace',
  },
} as const;
